import { HTTP } from '@/utils/http';
import * as actionTypes from '../types/actions';
import * as getterTypes from '../types/getters';
import * as mutationTypes from '../types/mutations';

export default {
  actions: {
    async [actionTypes.DO_GET_ARTICLE]({ commit }, payload) {
      const { id, ...params } = payload;
      const { data } = await HTTP.get(`/articles/${id}`, { params });
      commit(mutationTypes.SET_ARTICLE, data.data.articles[0]);
      return data;
    },
  },
  getters: {
    [getterTypes.GET_ARTICLE]: state => state.article,
    [getterTypes.GET_ARTICLES]: state => state.articles,
  },
  mutations: {
    [mutationTypes.SET_ARTICLE](state, payload) {
      state.article = payload;
    },
    [mutationTypes.SET_ARTICLES](state, payload) {
      state.articles = payload;
    },
  },
  state: {
    article: {},
    articles: [],
  },
};
